<template>
  <header class="modern-header">
    <div class="left-section">
      <!-- 只有 PC 端显示三条杠，手机端彻底隐藏 -->
      <div 
        v-if="!isMobile" 
        class="toggle-menu" 
        @click="$emit('toggleMenu')"
      >
        <i class="fas fa-bars"></i>
      </div>
      <div v-else>
        <div class="logo1">
      <i class="fas fa-chart-line"></i>
      <span >额度管家</span>
         </div>
      </div>
    </div>

    <div class="right-section">
      <div class="user-status">
        <span class="username">{{ username }}</span>
        <span :class="['status-dot', isOnline ? 'online' : 'offline']"></span>
        <button @click="toggleLogoutMenu" class="more-btn">⋯</button>

        <ul v-if="showLogout" class="logout-menu">
          <li @click="$emit('logout')">
            <i class="fas fa-sign-out-alt"></i> 退出登录
          </li>
          <li @click="changePassword">
            <i class="fas fa-key"></i> 修改密码
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
import { ref, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";

export default {
  props: {
    username: { type: String, required: true },
    isOnline: { type: Boolean, required: true },
  },
  setup() {
    const showLogout = ref(false);
    const isMobile = ref(window.innerWidth <= 768);
    const router = useRouter();

    const toggleLogoutMenu = () => {
      showLogout.value = !showLogout.value;
    };

    const changePassword = () => {
      router.push("/change");
    };

    const handleResize = () => {
      isMobile.value = window.innerWidth <= 768;
    };

    onMounted(() => window.addEventListener("resize", handleResize));
    onUnmounted(() => window.removeEventListener("resize", handleResize));

    return {
      showLogout,
      toggleLogoutMenu,
      changePassword,
      isMobile,
    };
  },
};
</script>

<style scoped>
.modern-header {
  padding: 16px 20px;
  padding-top: 20px;           /* 增加顶部留白，防止被 Sidebar 顶部挡住 */
  background: rgba(15, 23, 42, 0.95);
  backdrop-filter: blur(20px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  position: sticky;
  top: 0;
  z-index: 300;                /* Header z-index 保持 300 */
  border-bottom: 1px solid rgba(148, 163, 184, 0.2);
  color: #f1f5f9;
  height: 52px;                /* 固定高度，更稳定 */
}

.left-section { display: flex; align-items: center; }

.toggle-menu {
  padding: 10px 14px;
  cursor: pointer;
  border-radius: 12px;
  font-size: 22px;
  color: #cbd5e1;
}

.toggle-menu:hover { background: rgba(148, 163, 184, 0.15); }

.right-section { display: flex; align-items: center; }

.user-status {
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
}

.username { font-weight: 600; font-size: 15.5px; color: #f1f5f9; }

.status-dot {
  width: 11px; height: 11px; border-radius: 50%;
  border: 2px solid #0f172a;
}

.online { background-color: #22c55e; }
.offline { background-color: #ef4444; }

.more-btn {
  background: none; border: none;
  font-size: 24px; color: #cbd5e1;
  cursor: pointer; padding: 6px 10px;
  border-radius: 10px;
}

.more-btn:hover { background: rgba(148, 163, 184, 0.15); }

.logout-menu {
  position: absolute; top: 100%; right: 0; margin-top: 10px;
  background: rgba(15, 23, 42, 0.98); backdrop-filter: blur(16px);
  border: 1px solid rgba(148, 163, 184, 0.3); border-radius: 14px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.5);
  list-style: none; padding: 10px 0; min-width: 170px; z-index: 400;
  color: #e2e8f0;
}

.logout-menu li {
  padding: 14px 20px; display: flex; align-items: center; gap: 12px;
  cursor: pointer; font-size: 14.5px;
}

.logout-menu li:hover { background: rgba(148, 163, 184, 0.15); }


/* Logo 区域 */
.logo1 {
  display: flex;
  align-items: center;
  gap: 12px;
  /* padding: 24px 20px; */
  border-bottom: 1px solid #1e2937;
}

.logo1 i {
  font-size: 28px;
  color: #60a5fa;
}

.logo1 span {
  font-size: 18px;
  font-weight: 700;
  background: linear-gradient(135deg, #60a5fa, #a855f7);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
</style>